export interface NavLink {
  id: string;
  label: string;
}

export interface StatItem {
  value: string;
  label: string;
}

export interface CategoryItem {
  id: string;
  name: string;
  count: string;
  icon: string;
  desc: string;
}

export interface ModelItem {
  id: string;
  name: string;
  alias: string;
  style: string;
  albums: number;
  followers: string;
  tag: string;
  cover: string;
}

export interface BehindItem {
  id: string;
  title: string;
  desc: string;
  date: string;
  image: string;
}

export interface GuideItem {
  id: string;
  icon: string;
  title: string;
  summary: string;
  detail: string;
}

export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export const navLinks: NavLink[] = [
  { id: "latest", label: "最新更新" },
  { id: "collections", label: "精选合集" },
  { id: "models", label: "人气女主" },
  { id: "archive", label: "高清珍藏库" },
  { id: "scenes", label: "拍摄花絮" },
  { id: "guide", label: "收藏指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStats: StatItem[] = [
  { value: "12,800+", label: "写真合集" },
  { value: "3.6 亿", label: "累计浏览" },
  { value: "每日", label: "持续更新" },
  { value: "4K", label: "高清原图" },
];

export const categories: CategoryItem[] = [
  {
    id: "private",
    name: "私拍写真",
    count: "3,240 组",
    icon: "ri-camera-lens-line",
    desc: "一对一拍摄的私密写真，画面更松弛自然，光影与情绪并重，是最受收藏者欢迎的类别。",
  },
  {
    id: "fashion",
    name: "时尚写真",
    count: "2,180 组",
    icon: "ri-vip-diamond-line",
    desc: "以杂志大片为标准的棚拍与造型写真，强调服装质感与人物气场，适合欣赏审美与构图。",
  },
  {
    id: "outdoor",
    name: "户外外拍",
    count: "1,960 组",
    icon: "ri-sun-line",
    desc: "天台、海边、街巷等实景外拍，自然光与城市背景交融，画面通透，氛围感强烈。",
  },
  {
    id: "daily",
    name: "居家日常",
    count: "1,540 组",
    icon: "ri-home-smile-line",
    desc: "卧室、书房、落地窗边的居家场景，柔和光线营造慵懒真实的生活气息，观感亲近。",
  },
  {
    id: "uniform",
    name: "制服系列",
    count: "1,020 组",
    icon: "ri-shirt-line",
    desc: "学院风与职业风制服造型，干净的配色与利落的线条，展现人物不同的一面。",
  },
  {
    id: "film",
    name: "复古胶片",
    count: "860 组",
    icon: "ri-film-line",
    desc: "以胶片质感呈现的写真，颗粒、偏色与柔和反差让画面更具年代感与故事性。",
  },
];

export const models: ModelItem[] = [
  {
    id: "model-su",
    name: "苏念",
    alias: "Su Nian",
    style: "丝质长裙 · 柔和氛围",
    albums: 268,
    followers: "48.2 万",
    tag: "本周人气第一",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20east%20asian%20woman%20portrait%20in%20flowing%20silk%20dress%2C%20soft%20warm%20studio%20lighting%2C%20plain%20cream%20backdrop%2C%20refined%20editorial%20glamour%20aesthetic%2C%20gentle%20expression%2C%20shallow%20depth%20of%20field%2C%20tasteful%20and%20high%20detail&width=700&height=900&seq=yv-model-su&orientation=portrait",
  },
  {
    id: "model-lin",
    name: "林亦薇",
    alias: "Lin Yiwei",
    style: "落地窗 · 白衬衫",
    albums: 214,
    followers: "39.7 万",
    tag: "清新自然",
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20east%20asian%20woman%20portrait%20wearing%20crisp%20white%20shirt%20beside%20tall%20window%2C%20bright%20diffused%20daylight%2C%20minimal%20warm%20beige%20interior%2C%20natural%20relaxed%20pose%2C%20soft%20film%20tones%2C%20editorial%20portrait%20photography%2C%20elegant%20and%20clean%20composition&width=700&height=900&seq=yv-model-lin&orientation=portrait",
  },
  {
    id: "model-gu",
    name: "顾清欢",
    alias: "Gu Qinghuan",
    style: "天台逆光 · 城市",
    albums: 189,
    followers: "33.1 万",
    tag: "氛围感担当",
    cover:
      "https://readdy.ai/api/search-image?query=Stylish%20east%20asian%20woman%20portrait%20on%20city%20rooftop%20at%20golden%20hour%2C%20backlit%20rim%20light%2C%20urban%20skyline%20bokeh%20background%2C%20warm%20amber%20tones%2C%20cinematic%20editorial%20mood%2C%20graceful%20confident%20pose%2C%20high%20detail&width=700&height=900&seq=yv-model-gu&orientation=portrait",
  },
  {
    id: "model-shen",
    name: "沈曜",
    alias: "Shen Yao",
    style: "复古胶片 · 红裙",
    albums: 156,
    followers: "27.5 万",
    tag: "胶片质感",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20styled%20east%20asian%20woman%20portrait%20in%20deep%20red%20dress%2C%20retro%20film%20grain%20texture%2C%20warm%20muted%20palette%2C%20old%20street%20alley%20background%20softly%20blurred%2C%20nostalgic%20editorial%20cinematic%20look%2C%20elegant%20timeless%20aesthetic&width=700&height=900&seq=yv-model-shen&orientation=portrait",
  },
  {
    id: "model-wen",
    name: "温瑜",
    alias: "Wen Yu",
    style: "棚拍大片 · 造型",
    albums: 241,
    followers: "42.9 万",
    tag: "时尚大片",
    cover:
      "https://readdy.ai/api/search-image?query=Fashion%20magazine%20style%20east%20asian%20woman%20portrait%20in%20modern%20couture%20outfit%2C%20muted%20morandi%20color%20studio%20backdrop%2C%20clean%20dramatic%20softbox%20lighting%2C%20sculptural%20pose%2C%20high%20fashion%20editorial%20photography%2C%20refined%20and%20polished&width=700&height=900&seq=yv-model-wen&orientation=portrait",
  },
  {
    id: "model-jiang",
    name: "江晚吟",
    alias: "Jiang Wanyin",
    style: "海边黄昏 · 剪影",
    albums: 173,
    followers: "30.4 万",
    tag: "治愈系",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20east%20asian%20woman%20portrait%20at%20seaside%20during%20dusk%2C%20soft%20pink%20and%20gold%20sky%2C%20breeze%20in%20hair%2C%20flowing%20light%20summer%20dress%2C%20dreamy%20pastel%20tones%2C%20cinematic%20peaceful%20mood%2C%20gentle%20romantic%20editorial%20photography&width=700&height=900&seq=yv-model-jiang&orientation=portrait",
  },
];

export const behindScenes: BehindItem[] = [
  {
    id: "scene-01",
    title: "一场私拍写真的完整流程",
    desc: "从确定主题、挑选服装到布光与试拍，一组完整的私拍通常需要 4 到 6 个小时。摄影师会先用一盏主灯确定人物轮廓，再补一盏柔光灯压暗背景，最后用反光板收拢面部光线，让皮肤质感更通透。",
    date: "2026-09-28",
    image:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photo%20studio%20setup%20with%20softbox%20lights%20and%20reflector%2C%20warm%20cream%20seamless%20backdrop%2C%20clothing%20rack%20with%20elegant%20dresses%2C%20calm%20minimal%20atmosphere%2C%20documentary%20photography%2C%20warm%20neutral%20tones%2C%20high%20detail&width=900&height=700&seq=yv-scene-01&orientation=landscape",
  },
  {
    id: "scene-02",
    title: "自然光外拍的时间选择",
    desc: "户外外拍最讲究时间。日出后一小时与日落前一小时的光线柔和且带有暖调，被称作黄金时段。摄影师会提前踩点确定机位，用建筑的阴影做柔光，再用长焦压缩背景，让城市线条更干净。",
    date: "2026-09-21",
    image:
      "https://readdy.ai/api/search-image?query=Photographer%20with%20camera%20on%20city%20rooftop%20during%20golden%20hour%2C%20warm%20sunlight%20streaks%2C%20tripod%20and%20lens%20bag%2C%20soft%20urban%20background%20blur%2C%20documentary%20behind%20the%20scenes%20photography%2C%20amber%20and%20cream%20tones&width=900&height=700&seq=yv-scene-02&orientation=landscape",
  },
  {
    id: "scene-03",
    title: "后期调色的统一标准",
    desc: "同一组写真要保持色调一致。后期通常会先统一白平衡，再压低高光保留皮肤细节，最后用曲线营造柔和的胶片反差。天空与肤色是两大重点，既要通透又不能过饱和，保证长时间观看也舒服。",
    date: "2026-09-14",
    image:
      "https://readdy.ai/api/search-image?query=Photo%20editing%20workspace%20with%20color%20grading%20monitor%20and%20keyboard%2C%20warm%20soft%20desk%20lamp%20light%2C%20photography%20prints%20and%20color%20cards%20on%20desk%2C%20calm%20creative%20studio%20ambience%2C%20warm%20neutral%20tones%2C%20high%20detail&width=900&height=700&seq=yv-scene-03&orientation=landscape",
  },
];

export const guides: GuideItem[] = [
  {
    id: "guide-01",
    icon: "ri-eye-line",
    title: "先看构图，再看人物",
    summary: "判断一组写真是否值得收藏，构图往往比颜值更能决定耐看程度。",
    detail:
      "优秀的写真会用三分法、引导线或框架式构图把视线稳定在人物身上。收藏时可以先看画面的视觉重心是否清晰，再看人物与背景的比例关系。背景越简洁、线条越干净，画面越经得起反复观看。",
  },
  {
    id: "guide-02",
    icon: "ri-sun-fill",
    title: "光线决定质感",
    summary: "同样是私拍，柔光与硬光呈现的皮肤质感完全不同。",
    detail:
      "柔光能让肌肤过渡自然、阴影边缘柔和，适合清新治愈的风格；硬光会强化轮廓与立体感，适合气场强烈的时尚大片。收藏时可以对比同一拍摄者的不同用光手法，能更快建立自己的审美偏好。",
  },
  {
    id: "guide-03",
    icon: "ri-folders-line",
    title: "按主题整理收藏",
    summary: "把写真按主题分组，比单张堆叠更容易回看和查找。",
    detail:
      "建议按「私拍」「外拍」「胶片」等主题建立文件夹，并在命名中保留拍摄日期与造型关键词。这样在回看时既能按情绪筛选，也能观察同一拍摄者在不同阶段的风格变化，收藏价值更高。",
  },
  {
    id: "guide-04",
    icon: "ri-timer-line",
    title: "关注更新节奏",
    summary: "稳定的更新频率，往往意味着更成熟的拍摄与后期流程。",
    detail:
      "持续更新的拍摄者通常有固定的造型与调色标准，画面质量更稳定。订阅更新后，可以优先查看新发布的合集，再回头补看往期作品，既能跟上节奏，也不会因为一次性浏览过多而审美疲劳。",
  },
];

export const faqs: FaqItem[] = [
  {
    id: "faq-01",
    q: "本站主要提供哪些内容？",
    a: "本站专注整理高清写真集、福利图片与私拍美图，涵盖私拍写真、时尚写真、户外外拍、居家日常、制服系列与复古胶片等类别，均以人像审美与摄影质感为核心，页面内即可按类别浏览。",
  },
  {
    id: "faq-02",
    q: "更新频率是怎样的？",
    a: "页面上的「最新更新」分区会持续整理新上架的写真合集，通常按周更新。订阅更新后，你可以在第一时间看到新增的合集与拍摄花絮。",
  },
  {
    id: "faq-03",
    q: "如何快速找到想看的内容？",
    a: "可以使用顶部导航跳转到对应分区，在「最新更新」里按类别标签切换，或在「高清珍藏库」中直接输入关键词搜索、点选标签进行筛选，结果全部来自本页已有内容。",
  },
  {
    id: "faq-04",
    q: "图片可以保存收藏吗？",
    a: "本站内容仅供个人浏览与审美欣赏。请勿用于任何商业用途或二次传播，具体请以站内说明为准，尊重每一位拍摄者与模特的创作。",
  },
  {
    id: "faq-05",
    q: "写真里的模特信息准确吗？",
    a: "「人气女主」中展示的名称、风格与数据为页面展示用的整理信息，用于帮助浏览者快速了解不同拍摄风格，并非官方认证资料。",
  },
  {
    id: "faq-06",
    q: "在手机上浏览方便吗？",
    a: "方便。页面针对手机做了自适应排版，卡片会自动调整为单列或双列，筛选与搜索控件也都支持触屏与键盘操作，密集内容在手机上也保持可读。",
  },
];